import React from 'react';
import { useSelector } from 'react-redux';
import { Grid } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';


const useStyles = makeStyles(() => ({
  root: {
    backgroundColor: '#F6F6F9',
    color: '#32324D',
    padding: '10px'
  },
  title: {
    textTransform: 'uppercase',
    color: '#A7A7A7',
    padding: '10px 10px 5px 10px',
    fontWeight: 600
  },
  value: {
    padding: '0 10px 10px 10px'
  }
}));

const getProductType = (sku) => {
  if (sku.includes('PROD')) {
    return 'Product';
  } else if (sku.includes('TREAT')) {
    return 'Treatment';
  } else if (sku.includes('MEMBER')) {
    return 'Membership';
  }

  return '-';
};

const QuoteProductInfoTable = ({ sku, product }) => {
  const classes = useStyles();
  const { allBrands } = useSelector((state: IReduxState) => state.brands);

  const productBrandId = product?.custom_attributes?.find((attr) => attr.attribute_code === 'brand')?.value;
  const brand =  allBrands.find((brand) => brand.id == productBrandId)?.value || (new URLSearchParams(window.location.search)).get('brand');

  return (
    <Grid container spacing={0} className={classes.root}>
      <Grid item xs={12} sm={4}>
        <div className={classes.title}>sku</div>
        <div className={classes.value}>{sku}</div>
      </Grid>
      <Grid item xs={12} sm={4}>
        <div className={classes.title}>type</div>
        <div className={classes.value}>{getProductType(sku)}</div>
      </Grid>
      <Grid item xs={12} sm={4}>
        <div className={classes.title}>brand</div>
        <div className={classes.value}>{brand || '-'}</div>
      </Grid>
    </Grid>
  );
};

export default QuoteProductInfoTable;
